module.exports = __webpack_public_path__ + "fba4e2062dfdfbd0926420aa0c77a313.png";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader!./src/img/demo/bar-chart.png
// module id = 1827
// module chunks = 0